export class InvalidSalesPeriodError extends Error {}
